import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import trans from 'translate';
import { openSupportedTokensModal } from '../../../../redux/actions/modalActions';
import pancakeswapImg from '../../../../images/pancakeswap-icon.png';

function SupportedTokensLink({ openSupportedTokensModal, text, hideImg }) {
  return (
    <span className="d-flex gap-sm pointer align-center" onClick={openSupportedTokensModal}>
      {!hideImg && <img width={20} height={20} className="" src={pancakeswapImg} alt="pancakeswap" />}
      {trans(text)}
    </span>
  );
}

const mapDispatchToProps = {
  openSupportedTokensModal,
};
SupportedTokensLink.defaultProps = {
  text: 'hpool.supported_tokens',
  hideImg: false,
};

SupportedTokensLink.propTypes = {
  openSupportedTokensModal: PropTypes.func.isRequired,
  text: PropTypes.string,
  hideImg: PropTypes.bool,
};

export default connect(null, mapDispatchToProps)(SupportedTokensLink);
